import { render } from "./ScheduleCard.vue?vue&type=template&id=333ec65a&scoped=true"
import script from "./ScheduleCard.vue?vue&type=script&lang=js"
export * from "./ScheduleCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333ec65a"]])

export default __exports__